import { IconCalendar, IconLiquidity, theme } from '@capitalise/ui-design-system';
import { formatCurrency, formatNumber } from 'utils/NumberHelper';
import ProductInfo from './ProductInfo';
import PropTypes from 'prop-types';

const ProductLoanDescription = ({
  maximumAmount,
  term,
  representativeAPR = null,
  monthlyRepayment = null,
}) => {
  return (
    <>
      <ProductInfo
        value={formatCurrency(maximumAmount)}
        label="Loan Amount"
        icon={<IconLiquidity color="grey-500" width={theme.sizes['tiny']} />}
      />
      <ProductInfo
        value={`${term} months`}
        label="Term"
        icon={<IconCalendar color="grey-500" width={theme.sizes['3xsmall']} />}
      />
      <ProductInfo
        value={representativeAPR ? `${formatNumber(representativeAPR, '0.0')} %` : '-'}
        label="APR"
        icon={'%'}
      />
      <ProductInfo
        value={monthlyRepayment ? formatCurrency(monthlyRepayment) : '-'}
        label="Monthly repayment"
        icon={<IconLiquidity color="grey-500" width={theme.sizes['tiny']} />}
      />
    </>
  );
};

ProductLoanDescription.propTypes = {
  maximumAmount: PropTypes.number,
  term: PropTypes.number,
  representativeAPR: PropTypes.number,
  monthlyRepayment: PropTypes.number,
};

export default ProductLoanDescription;
